import { Switch } from 'react-router-dom';
import { RouteConfigMap } from './_utils/route-config-map';
import { INTEGRATION_ROUTES } from './config/routes-integration';

export function RouteSwitchIntegration() {
  return (
    <Switch>
      <RouteConfigMap routeConfig={INTEGRATION_ROUTES} />
    </Switch>
  );
}
